module.exports = __webpack_public_path__ + "static/media/switch.a3778d58.mp3";